<template>
  <b-col>
    <SearchCard
      :filterCatch="true"
      :title="$lang.azmoonLang.question_title_list"
      :url="url"
      :html="false"
      ref="searchTitle"
      @updatePermissions="updatePermissions"
      :hasAdd="true"
      @handleAdd="createTitle"
    >
      <template slot="html" slot-scope="{ item }">
        <b-col
          class="border-bottom my-1 py-2 d-flex align-items-center"
          cols="12"
        >
          <div>
            <span
              class="circle_main"
              v-b-tooltip.hover
              :title="$lang.azmoonLang.number_question"
            >
              <i class="fas fa-question"></i>
            </span>
          </div>

          <b class="mx-1">{{ item.id }}</b>
        </b-col>
        <b-col cols="12">
          <div
            class="text-description"
            ref="textQuestion"
            v-html="createPureDom(item.title_description)"
          ></div>
        </b-col>
        <b-col class="border-top py-2" cols="12">
          <div class="float-right">
            <b-button
              v-if="isAdmin(permissions)"
              @click="changetitle(item)"
              class="mx-1"
              variant="outline-success"
              size="sm"
            >
              <i class="fa fa-edit fa-lg mr-1" />
              <b v-text="$lang.search.edit_tooltip" />
            </b-button>
            <b-button
              v-if="isAdmin(permissions, ['admin'])"
              @click="removing(item)"
              class="mx-1"
              variant="outline-danger"
              size="sm"
            >
              <i class="fas fa-times mr-1" />
              <b v-text="$lang.search.remove_tooltip" />
            </b-button>
          </div>

          <b-badge
            v-b-tooltip.hover
            class="mx-1"
            :variant="item.is_enable ? `success` : `danger`"
            >{{ item.is_enable ? $lang.enable : $lang.disable }}</b-badge
          >
        </b-col>
      </template>
    </SearchCard>
    <b-modal
      no-close-on-backdrop
      variant="primary"
      header-bg-variant="primary"
      content-class="border-primary"
      v-model="view_title"
      size="xl"
      ok-only
      hide-footer
      hide-header
    >
      <div v-if="mode === 'edit'">
        <EditQuestionTitle
          :item="itemTitle"
          @cancel="cancelTitle"
          @getItems="getItems"
          :permissions="permissions"
        />
      </div>
      <div v-if="mode === 'add'">
        <AddQuestionTitle
          @cancel="cancelTitle"
          @getItems="getItems"
          :permissions="permissions"
        />
      </div>
    </b-modal>

    <Confirm
      :title="modalTitle"
      :description="message"
      :loading="confirmModalLoading"
      v-model="confirmModal"
      :ok-title="$lang.yes"
      :cancel-title="$lang.no"
      @ok="confirmedRemoveItem"
      @cancel="notConfirmedRemoveItem"
    />
  </b-col>
</template>

<script>
import SearchCard from "@/components/base/searchCard";
import AddQuestionTitle from "./addQuestionTitle";
import EditQuestionTitle from "./editQuestionTitle";
import Confirm from "@/components/base/confirm";
import { isAdmin } from "@/shared/utils";
import { pathOr } from "ramda";
import { createPureDom } from "@/shared/utils";

export default {
  name: "search-question-title",
  components: {
    AddQuestionTitle,
    SearchCard,
    EditQuestionTitle,
    Confirm,
  },
  data() {
    return {
      items: [],
      url: this.$config.api_url + this.$config.azmoon.title,
      view_title: false,
      mode: "",
      itemTitle: {},
      modalTitle: null,
      confirmModal: false,
      message: null,
      removingItem: null,
      permissions: [],
      confirmModalLoading: false,
    };
  },
  methods: {
    isAdmin,
    pathOr,
    createPureDom,
    updatePermissions(data) {
      this.permissions = data;
    },
    notConfirmedRemoveItem() {
      this.removingItem = null;
      this.message = "";
      this.confirmModal = false;
    },
    async confirmedRemoveItem() {
      try {
        this.confirmModalLoading = true;
        const id = pathOr(null, ["id"], this.removingItem);
        const url = `${this.url}/${id}`;
        const response = await this.$httpService.delete(url);
        this.$notify.success(response.data.message);
        this.getItems();
        this.notConfirmedRemoveItem();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.confirmModalLoading = false;
      }
    },
    removing(item) {
      this.removingItem = item;
      this.message = this.$lang.are_you_sure_to_remove_item;
      this.modalTitle = this.$lang.remove_item;
      this.confirmModal = true;
    },
    changetitle(item) {
      this.mode = "edit";
      this.itemTitle = item;
      this.view_title = true;
    },
    cancelTitle() {
      this.view_title = false;
    },
    createTitle() {
      this.mode = "add";
      this.itemTitle = {};
      this.view_title = true;
    },
    getItems() {
      this.view_title = false;
      this.$refs.searchTitle.getItems();
    },
  },
  created() {},
};
</script>

<style>
.circle_main {
  width: 25px;
  height: 25px;
  background-color: lightgray;
  border-radius: 60%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.img-title {
  width: 300px;
  height: auto;
  display: block;
  margin: auto;
}
</style>
